// Display label for a driver identified only by email (listDrivers exposes
// no name field): 'jordan.rivera@…' → 'Jordan Rivera'.
export default function driverLabel(emailAddress) {
  const localPart = (emailAddress || '').split('@')[0];
  if (!localPart) return '';
  return localPart
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
